module.exports = __webpack_public_path__ + "static/img/404@3x457d5db.png";